<template>
  <v-card outlined style="margin-bottom: 24px" v-if="profile && profile.student">
    <div class="d-flex justify-space-between align-items-center py-6 pl-6">
      <h5 class="text-uppercase align-self-center">Thông tin học sinh</h5>
    </div>

    <v-row class="px-6 pb-6" no-gutters>
      <v-col cols="4">
        <p class="grey--text mb-0 mt-0">Họ tên</p>
        <p class="my-0">{{ profile.student.name }}</p>
      </v-col>
      <v-col cols="4">
        <p class="grey--text mb-0 mt-0">Số báo danh</p>
        <p class="my-0">{{ profile.examCode }}</p>
      </v-col>
      <v-col cols="4">
        <p class="grey--text mb-0 mt-0">Mã học sinh</p>
        <p class="my-0">{{ profile.student.code_short }}</p>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
export default {
  props: {
    profile: Object,
    authorized: Boolean
  },
  components: {},
  data() {
    return {
      updateLeadDialog: false
    }
  },
  methods: {}
}
</script>
